/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deviceAuthActionEnumSchema } from "./deviceAuthActionEnumSchema.ts";

export const checkPhoneFromDeviceResponseSchema = z
	.object({
		action: deviceAuthActionEnumSchema.describe("* `login` - Авторизация\n* `register` - Регистрация"),
	})
	.describe("Сериализатор ответа проверки номера телефона на киоске.");
